module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"No elements found":"No elements found","List is empty":"List is empty","Select option":"Select option"},"it":{"No elements found":"Nessun elemento trovato","List is empty":"L\u0027elenco è vuoto","Select option":"Selezionare l\u0027opzione"}}')
  delete Component.options._Ctor
}
